import { DayItem } from './day-item';

export class MonthDays {
  constructor(
    monthName: string,
    monthNumber: number,
    monthColor: string,
    monthSummaryName: string,
    year: number,
    days: DayItem[]
  ) {
    this.monthName = monthName;
    this.monthNumber = monthNumber;
    this.monthColor = monthColor;
    this.monthSummaryName = monthSummaryName;
    this.year = year;
    this.days = days;
  }
  public monthName: string;
  public monthNumber: number;
  public monthColor: string;
  public monthSummaryName: string;
  public year:number;
  public days: DayItem[];
  public specificDay?:number;

}
